import Vue from 'vue';
import Vuex, { Module } from 'vuex';

import axios from 'axios';
import { handleError } from '@/utils/helperFunctions';

import { endpoints } from '../endpoints/endpoints';

Vue.use(Vuex);

export interface Snackbar {
  message: string | null;
  type: string | null;
  hasClose: boolean;
  hasIcon: boolean;
  autoClose: boolean;
}

export const snackbarInitialState: Snackbar = {
  message: null,
  type: 'default',
  hasClose: false,
  hasIcon: false,
  autoClose: false,
};


export const utils: Module<any, any> = {
  state: {
    snackbar: { ...snackbarInitialState },
    focusElement: null,
    addressDetails: null,
    projections: [],
    projectionDetails: null,
    projectionModal: null,
    missingDocuments: [],
    missingDocumentModal: null,
    openAccountExitModal: {
      isOpen: false,
      toPath: '',
    },
    backToAccountsListViewModal: false,
    resetPasswordModal: false,
    aofDeleteConfirmationModal: false,
  },
  mutations: {
    updateSnackbarMessage(state: any, data: Snackbar['message']) {
      state.snackbar.message = data;
      setTimeout(() => {
          state.snackbar = { ...snackbarInitialState };
        }, 4000);
    },
    updateSnackbar(state: any, data: Snackbar) {
      state.snackbar = data;
      if (data.autoClose === true) {
        setTimeout(() => {
          state.snackbar = { ...snackbarInitialState };
        }, 4000);
      }
    },
    updateFocusElement(state: any, data: string) {
      state.focusElement = data;
      setTimeout(() => {
        state.focusElement = null;
      }, 5000);
    },
    setAddressDetails(state: any, data: string) {
      state.addressDetails = data;
    },
    setProjections(state: any, data: string) {
      state.projections = data;
    },
    setProjectionDetails(state: any, data: string) {
      state.projectionDetails = data;
    },
    toggleProjectionModal(state: any, data: string) {
      state.projectionModal = data;
    },
    openAccountExitModal(state: any, data: any) {
      state.openAccountExitModal = data;
    },
    toggleResetPasswordModal(state: any, data: string) {
      state.resetPasswordModal = data;
    },
    aofDeleteConfirmationModal(state: any, data: string) {
      state.aofDeleteConfirmationModal = data;
    },
    backToAccountsListViewModal(state: any, data: boolean) {
      state.backToAccountsListViewModal = data;
    },
  },
  actions: {
    async getAddressDetails({commit}) {
      const res = await axios
      .get(endpoints.addressDetails + '?whitelabelID=' + this.state.account.details.whiteLabelId, {
        headers: {
          Authorization: 'bearer ' + this.state.account.token,
        },
      })
      .then((response) => {
        commit('setAddressDetails', response.data.Data);
        return response.data;
      })
      .catch((err) => {
        const msg = handleError(err, 'Sorry! Looks like something went wrong while trying to get your company address details');
        this.dispatch('addError', msg);
      });
    },
    async getProjections({commit}, data) {
      const res = await axios
      .get(endpoints.projections + '?expRatedOfReturn=' + data.expRatedOfReturn +
      '&yearlyContribution=' + data.yearlyContribution +
      '&currentValue=' + data.currentValue +
      '&baseCurrency=' + data.baseCurrency +
      '&referenceCurrency=' + data.referenceCurrency, {
        headers: {
          Authorization: 'bearer ' + this.state.account.token,
        },
      })
      .then((response) => {
        commit('setProjections', response.data.Data);
        return response.data;
      })
      .catch((err) => {
        const msg = handleError(err, 'Sorry! Looks like something went wrong while trying to get the projected values');
        this.dispatch('addError', msg);
      });
    },
    async setProjectionDetails({commit}, data) {
      if (data) {
        commit('setProjectionDetails', data);
        if (data.location === 'modal') {
          this.dispatch('toggleProjectionModal', true);
        }
      } else {
        commit('setProjectionDetails', null);
        commit('setProjections', []);
      }
    },

    async toggleProjectionModal({commit}, data) {
      if (!data) {
        this.dispatch('setProjectionDetails');
        commit('toggleProjectionModal', data);
      } else {
        commit('toggleProjectionModal', data);
      }
    },
    openAccountExitModal({commit}, data) {
      commit('openAccountExitModal', data);
    },
    backToAccountsListViewModal({commit}, data) {
      commit('backToAccountsListViewModal', data);
    },
    toggleResetPasswordModal({ commit }, data) {
      commit('toggleResetPasswordModal', data);
    },
    toggleAofDeleteConfirmationModal({ commit }, data) {
      commit('aofDeleteConfirmationModal', data);
    },
  },
};
